import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { PaginatedResponse, StyleIdDataAggregated } from "@/types/common.types";
import { useInfiniteQuery } from "@tanstack/react-query";

export type JobStyleDataItemAggregated = {
  id: number;
  processTime: string;
  status: "SUCCESS" | "FAILURE" | string;
  pdpData: StyleIdDataAggregated;
  jobStyleAssignment: {
    id: number;
  };
};

export type JobStyleDataResponseAggregated =
  PaginatedResponse<JobStyleDataItemAggregated>;

const getJobStyleData = async ({
  pageParam,
  jobId,
  size,
  styleId,
}: {
  pageParam: number;
  jobId: string;
  size: number;
  styleId?: string;
}): Promise<JobStyleDataResponseAggregated> => {
  return apiClient
    .get(
      ENDPOINTS.GET_SCHEDULED_JOB_STYLE_DETAILS_AGGREGATED(
        jobId,
        pageParam,
        size,
        styleId
      )
    )
    .json<JobStyleDataResponseAggregated>();
};

export const useJobStyleDataAggregatedQuery = (
  jobId: string | null,
  size: number = 50,
  styleId?: string
) => {
  return useInfiniteQuery({
    queryKey: ["jobStyleDataAggregated", jobId, size, styleId] as const,
    initialPageParam: 0,
    queryFn: async ({ pageParam }) => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return getJobStyleData({ pageParam, jobId, size, styleId });
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined;
      }
      return lastPage.page + 1;
    },
  });
};
